@let _marketsLength = marketsLength();
@if (showHeader && isCompetitionView()) {
  <div class="header">
    <span class="title"> {{ pageTitle | translate }} </span>
  </div>
}
@if (_marketsLength === 0 && !($loading | async) && !isLoadingStatus()) {
  <app-status-alert
    [config]="{
      title: 'No Markets Available',
      subtitle: 'There are no events available at the moment. Please check back later.',
      type: 'info',
      mode: 'block',
      icon: 'event_busy',
    }" />
}
<app-highlight-loader [show]="_marketsLength === 0 && (($loading | async) || isLoadingStatus())" />
@if (_marketsLength > 0) {
  <div class="highlight-content">
    <table>
      <thead>
        <tr>
          <th style="padding: 0; position: relative">
            <div class="e-th" (click)="toggleDropdown('event', $event)" style="cursor: pointer">
              <span> {{ "Event" | translate }} </span>
              <mat-icon class="tune-icon">tune</mat-icon>
            </div>
            @if (openDropdown() === "event") {
              <div class="custom-dropdown" (click)="$event.stopPropagation()">
                <div class="dropdown-item" [class.active]="isSortActive('marketStartTime', null)" (click)="onSort('marketStartTime', null); closeDropdown()">
                  <span>{{ "Default (Time)" | translate }}</span>
                  <mat-icon>schedule</mat-icon>
                </div>
                <div class="dropdown-item" [class.active]="isSortActive('eventName', 'asc')" (click)="onSort('eventName', 'asc'); closeDropdown()">
                  <span>{{ "Name - Ascending" | translate }}</span>
                  <mat-icon>sort_by_alpha</mat-icon>
                </div>
                <div class="dropdown-item" [class.active]="isSortActive('eventName', 'desc')" (click)="onSort('eventName', 'desc'); closeDropdown()">
                  <span>{{ "Name - Descending" | translate }}</span>
                  <mat-icon>sort_by_alpha</mat-icon>
                </div>
              </div>
            }
          </th>
          <th style="padding: 0; position: relative">
            <div class="matched-th" (click)="toggleDropdown('volume', $event)" style="cursor: pointer">
              <span> {{ "Volume" | translate }} </span>
              <mat-icon class="tune-icon">tune</mat-icon>
            </div>
            @if (openDropdown() === "volume") {
              <div class="custom-dropdown" (click)="$event.stopPropagation()">
                <div class="dropdown-item" [class.active]="isSortActive('marketStartTime', null)" (click)="onSort('marketStartTime', null); closeDropdown()">
                  <span>{{ "Default (Time)" | translate }}</span>
                  <mat-icon>schedule</mat-icon>
                </div>
                <div class="dropdown-item" [class.active]="isSortActive('totalMatched', 'asc')" (click)="onSort('totalMatched', 'asc'); closeDropdown()">
                  <span>{{ "Volume - Ascending" | translate }}</span>
                  <mat-icon>trending_up</mat-icon>
                </div>
                <div class="dropdown-item" [class.active]="isSortActive('totalMatched', 'desc')" (click)="onSort('totalMatched', 'desc'); closeDropdown()">
                  <span>{{ "Volume - Descending" | translate }}</span>
                  <mat-icon>trending_down</mat-icon>
                </div>
              </div>
            }
          </th>
          @for (item of tHeaders; track item) {
            <th colspan="2">
              <div class="t-header-content">
                {{ item | translate }}
              </div>
            </th>
          }
          <th style="padding: 0">
            <div class="t-header-content">
              <mat-icon>more_horiz</mat-icon>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Ghost row to maintain column widths when collapsed -->
        <tr class="ghost-row">
          <td class="event-td"></td>
          <td class="matched-td"></td>
          @for (item of tHeaders; track item) {
            <td class="odd-cell"></td>
            <td class="odd-cell"></td>
          }
          <td class="action-td"></td>
        </tr>
        @if (groupedMarkets(); as groups) {
          @for (group of groups; track group.id) {
            <tr class="comp-row" (click)="toggleLeagueCollapse(group.id)" style="cursor: pointer">
              <td [attr.colspan]="tHeaders.length * 2 + 3">
                <div class="comp-header">
                  <span>{{ group.name }}</span>
                  <mat-icon class="toggle-icon">
                    {{ isLeagueCollapsed(group.id) ? "keyboard_arrow_right" : "keyboard_arrow_down" }}
                  </mat-icon>
                </div>
              </td>
            </tr>
            @if (!isLeagueCollapsed(group.id)) {
              @for (market of group.markets; track market.marketId) {
                <tr app-h-row [market]="market"></tr>
              }
            }
          }
        } @else {
          @for (market of markets(); track market?.marketId) {
            <tr app-h-row [market]="market"></tr>
          }
        }
      </tbody>
    </table>
  </div>
}
